<se-fe-card
  class="eventCard"
  [style]="'border-color:' + cardAccentColor +';'">
  <se-fe-card-content class="cardContent">
    <div *ngIf="dataEvent.tags && dataEvent.tags.length > 0">
      <span *ngFor="let tag of dataEvent.tags" [class]="'pl-tag--' + tag.color">{{ tag.value.toUpperCase() }}</span>
    </div>
    <p *ngIf="(!dataEvent.tags || dataEvent.tags.length === 0) && range">{{ range }}</p>
    <se-fe-header>
      <a seFeHeaderTitle
        seFeLink="low"
        *ngIf="dataEvent.titleAttributes"
        [href]="dataEvent.titleAttributes.href || undefined "
        class="se-event-card__title">
        {{ dataEvent.title }}
      </a>
      <div seFeHeaderTitle
        *ngIf="!dataEvent.titleAttributes"
        class="se-event-card__title">
        {{ dataEvent.title }}
      </div>
      <div seFeHeaderSubtitle
        *ngIf="dataEvent.subtitle"
        class="se-event-card__subtitle">
        {{ dataEvent.subtitle }}
      </div>
      <div *ngIf="playChipOpts"  seFeHeaderActions>
        <se-fe-play-chip
          [attr.seFeDataOptions]="playChipOpts">
        </se-fe-play-chip>
      </div>
    </se-fe-header>

    <a *ngIf="dataEvent.locationAttributes"
      seFeLink="low"
      [href]="dataEvent.locationAttributes.href || undefined"
      class="se-event-card__location">
      {{ dataEvent.location }}
    </a>
    <div *ngIf="!dataEvent.locationAttributes && dataEvent.location"
      class="se-event-card__location">
      {{ dataEvent.location }}
    </div>
    <app-rsvp-list
      [rsvps]="rsvps || []"
      [hasAllRsvps]="hasAllRsvps()"
      [headerAvatars]="shownAvatars"
      [additionalAvatars]="avatarsNotShown"
      (onRsvp)="emitEvent($event)">
    </app-rsvp-list>
  </se-fe-card-content>
</se-fe-card>
